module.exports = __webpack_public_path__ + "static/media/pathe-signature.295e1a87.png";